import { render, staticRenderFns } from "./MerchantList.vue?vue&type=template&id=7c7d8b13&scoped=true"
import script from "./MerchantList.vue?vue&type=script&lang=js"
export * from "./MerchantList.vue?vue&type=script&lang=js"
import style0 from "./MerchantList.vue?vue&type=style&index=0&id=7c7d8b13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7d8b13",
  null
  
)

export default component.exports